<template>
    <div class="subject-cont">
       
        <ul class="cont-nav"> 
            <li v-for="(item,index) in navList" :key="index">
                <div @click="nav_click(item,index)" class="nav-val" :class="index==navIndex?'active':''">{{item.value}}分析</div>
            </li>
        </ul>
        <el-divider></el-divider>
        <div class="cont" v-loading='isLoad'>
             <!-- 饼图 -->
            <echartInfo v-if='isPie' ref='echart_info' :chartName='chartName' :echartList=listJson></echartInfo>
            <!-- 关联 -->
            <relevance v-if='isRelevance' ref='relevance_info'  :tableListAll=listJson></relevance> 
            <!-- 社团 -->
            <association v-if='isAssociation'  ref='association_info'  :dataList=listJson ></association>
            <!-- 复杂 -->
            <complex v-if='isComplex'  ref='complex_info'></complex>
            <!-- 聚类 -->
            <cluster v-if='isCluster'  ref='cluster_info' ></cluster>
        </div>
       
    </div>
</template>

<script>
import echartInfo from './echart_info.vue'
import relevance from './relevance.vue'
import association from './association.vue'
import cluster from './cluster.vue'
import complex from './complex.vue'
import subjectJson from './subjectJson.js'
export default {
    props: ['navList','treeType'],
    components: {
        echartInfo,
        relevance,
        association,
        complex,
        cluster
    },
    data () {
        return {
            isShowEacht:false, 
            navIndex:0,
            chartName:'中医疾病',
            isPie:false, 
            isRelevance:false,
            isAssociation:false,
            isCluster:false,
            isComplex:false,
            isLoad:false, 
            echartList:[],
            tableListAll:[], 
            dataList:[], 
            listJson:null
        }
    },
    watch: { 
    },
    mounted () {  
    },
    methods: { 
        nav_click(item,index,type){ 
            this.navIndex=index;
            this.chartName = item.value.replace('统计','');  
            this.initEchart();
            this.isLoad=true;  
            this.listJson=subjectJson[type?type:this.treeType][item.infoType];  
            console.log(item.type,'=tt')
            setTimeout(() => {
                if(item.type=='pie'){
                    this.isPie=true; 
                }else if(item.type=='relevance'){
                    this.isRelevance=true; 
                }else if(item.type=='association'){
                    this.isAssociation=true; 
                }else if(item.type=='cluster'){
                    this.isCluster=true;
                }else if(item.type=='complex'){
                    this.isComplex=true;
                }
                this.isLoad=false;
             }, 500);
            // this.isShowEacht=true;
        },
        initEchart(data){
            this.isPie=false;
            this.isRelevance=false;
            this.isAssociation=false;
            this.isCluster=false;
            this.isComplex=false;
        }
    }
}
</script>

<style lang="less" scoped>
.cont-nav{
    width: 900px;
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    li{
        width: 214px;
        margin :0 10px 10px 0;
       .nav-val{
            text-align: center;
            line-height: 40px;
            border-radius: 4px;
            background: #c6e2ff;
            color:#409EFF;
            font-weight: bold;
            cursor: pointer;
            // color: #fff;
            &.active{
                background: #409EFF;
                color: #fff;
            }
       }
    }
}
.cont{
    min-height: 400px;
}
</style>